export default {"src":"/_next/static/media/star.2fa1f49a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};